import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path d="M8 15V1" stroke="currentcolor" stroke-linejoin="bevel"/><path d="M13.018 10L8 15l-5.017-5" stroke="currentcolor"/></svg>`;

export { symbol as default };
